export const environment = {
  production: false,
  apiUrl: "https://api-appskills.davidson.group",
  adminAppUrl: "https://admin-appskills.davidson.group",
  frontVersion: "2",
};